import {cn} from '@/lib/utils'
import {useState} from 'react'
import {IWuAppHeaderSubMenuItem} from '../../../types/WuAppHeaderMenuItem'
import {iconMap} from '../../../utils/iconMap'

export const ProductItem: React.FC<{
  product: IWuAppHeaderSubMenuItem
  currentProduct?: string
  activeProductName: string
  dir?: 'ltr' | 'rtl'
  focusItem: string
  setFocusItem: (item: string) => void
}> = ({
  product,
  currentProduct,
  activeProductName,
  dir,
  focusItem,
  setFocusItem,
}) => {
  const [hover, setHover] = useState(product.name === currentProduct)
  const isActive = product.name === activeProductName
  const isCurrent = product.name === currentProduct
  const isLocked = !product.active

  const borderColorHoverOrActive = '#1b3380'
  const borderColorCommon = '#c5cce0'
  const borderColorLocked = '#ffcf70'

  const textClass = cn(
    'font-normal text-xs text-gray-lead text-center',
    isCurrent && 'text-blue-q font-normal',
    !product.active && 'text-gray-subtle',
    hover && 'font-normal',
    product.active && hover && 'text-blue-q',
  )

  const iconClass = cn(
    'text-blue-p text-base',
    isCurrent && 'text-blue-q',
    !product.active && 'text-gray-subtle',
    product.active && hover && 'text-blue-q',
  )

  const backgroundColor =
    hover || focusItem === product.name
      ? borderColorHoverOrActive
      : isActive
        ? borderColorHoverOrActive
        : borderColorCommon

  return (
    <li
      key={product.name}
      className={cn(
        'productListItem focus-visible:outline-none focus:outline-none wu-sub-product-list-item',
        (isActive || hover) && 'activeProduct',
        product.name.length > 'Instant Answers'.length &&
          window.innerWidth > 768 &&
          'w-[130px] min-w-[130px]',
        focusItem === product.name && 'activeProduct',
        'wu-product-item',
      )}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      aria-label={product.name}
      aria-disabled={isLocked}
      dir={dir}
      onKeyDown={event => {
        // While navigating product item using tab and press enter key it should open the link
        if (event.key === 'Enter') {
          event.preventDefault()
          const link = event.currentTarget.querySelector('a')
          if (link) {
            link.click()
          }
        }
      }}
      onFocus={() => {
        setFocusItem(product.name)
      }}
      onBlur={() => setFocusItem('')}
    >
      <div
        className={cn('topBorder', dir === 'rtl' && 'topBorderRtl')}
        style={{
          backgroundColor: isLocked ? borderColorLocked : backgroundColor,
        }}
      />
      <a
        className="productLink focus:outline-none focus-visible:outline-none"
        href={product.link || '#'}
        tabIndex={0}
      >
        <span
          className={cn(iconClass, iconMap[product.icon || ''])}
          aria-hidden
        />
        <span className={cn(textClass)}>{product.name}</span>
      </a>
    </li>
  )
}
